import Choices from 'choices.js';
import { createUniqueID } from '../functions/utils';

export default class Dropdown {
  constructor(element) {
    this.passedElement = element;
    this.init();
  }

  init = () => {
    if (!this.initialised) {
      this.initialised = true;
      this.createSelect();
      this.createIDs();
      this.addValidationClasses();
    }
  }

  createSelect = () => {
    this.select = new Choices(this.passedElement);
  }

  createIDs = () => {
    if (!this.passedElement.hasAttribute('id')) {
      let id = createUniqueID('select');
      this.passedElement.id = id;
      this.select.containerOuter.id = id;
    } else {
      this.select.containerOuter.id = this.passedElement.id;
    }
  }

  addValidationClasses = () => {
    (this.passedElement.classList.contains('is-valid')) ? this.select.containerOuter.element.classList.add('is-valid') : null;
    (this.passedElement.classList.contains('is-invalid')) ? this.select.containerOuter.element.classList.add('is-invalid') : null;
  }

  dismantle = () => {
    this.select.destroy();
    this.passedElement = null;
    this.select = null;
    this.initialised = true;
  }
}
